import React from "react";
import { Link } from "react-router-dom";
import ReactFlow, { Controls, Background, ControlButton, ConnectionLineType } from 'reactflow';
import { Loading, StyleTag } from "seed/helpers";
import l from "components/util/l";

import Node from "components/studio/board/nodes/Node";
import Edge from "components/studio/board/nodes/Edge";
import Note from "components/studio/board/annotations/Note";
import Pipe from "components/studio/board/annotations/Pipe";
import Text from "components/studio/board/annotations/Text";
import NodeAnnotation from "components/studio/board/annotations/Node";
import ActionItem from "components/studio/board/Board.sub.ActionItem.view";

import "styles/css/studio/board/Board.css";
import 'reactflow/dist/style.css';

const nodeTypes = {
  "pipe": Pipe,
  "note": Note,
  "node": Node,
  "node_annotation": NodeAnnotation,
  "text": Text,
}

const edgeTypes = {
  "edge": Edge
}


const BoardView = ({
  flow,
  nodes,
  edges,
  toolboxRef,
  initialViewport,
  boardFitView,
  reactFlowWrapper,
  annotations,
  showAnimations,
  numSelectedNodes,
  isFlowBeingSaved,
  isAnimationOptionShown,
  isPlaceholderShown,
  isControlsShown,
  isValidator,
  setReactFlowInstance,
  onDropNode,
  onDragNode,
  onClickConnectEdge,
  onClickUpdateEdge,
  onNodesChange,
  onEdgesChange,
  onDragStart,
  onClickAction,
  onClickDeleteSelectedNodes,
  onClickDeleteSelectedProcesses,
  onClickUndo,
  onClickRedo,
  onClickChangeAnimations,
  onClickDuplicateSelectedNodes,
}) => (

  <div id="board" className="w-100 h-100">
    <div ref={reactFlowWrapper} className="flow-wrapper">

      {/*flow.isReleaseVersion == true && (
        <div class="alert alert-warning text-center" role="alert" style={{
          position: "absolute",
          top: "0px", left: "0px", zIndex: 100, width: "100%" }}>
          <strong>Esta es la <u>versión de lanzamiento original</u> de este proceso, tenga precaución al modificarlo.</strong>
        </div>
        )*/}

      <ReactFlow
        defaultViewport={isControlsShown ? initialViewport : {}}
        fitView={isControlsShown ? boardFitView : true}
        fitViewOptions={isControlsShown ? {
          padding: 1,
          minZoom: 1.45,
          maxZoom: 1.7
        } : {}}
        minZoom={isControlsShown ? 0.7 : 0.3}
        maxZoom={1.7}
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        connectionMode={"loose"}
        connectionLineType={ConnectionLineType.SmoothStep}
        nodesFocusable={false}
        edgesFocusable={false}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onClickConnectEdge}
        onEdgeUpdate={onClickUpdateEdge}
        onInit={setReactFlowInstance}
        onDrop={onDropNode}
        onDragOver={onDragNode}
      >

        {isControlsShown && (
          <div className="mt-3 px-2"
            style={{ "position": "absolute", right: "0.8rem", zIndex: 5 }}>
            <div className="d-flex">

              <div class="btn-group h-100">

                <ActionItem
                  actions={annotations}
                  actionName={"annotation"}
                  className="btn btn-sm btn-board btn-lighter-white px-3"
                  type={"node"}
                  customTitle={l("Agregar nota%SA242")}
                  onDragStart={onDragStart}
                  onClickAction={onClickAction}
                />

              </div>

            </div>
          </div>
        )}

        {numSelectedNodes > 0 &&
          <div className="mt-1 px-2 mr-2 py-1"
            style={{ "position": "absolute", top: "60px", right: "0", zIndex: 5 }}>
            <button className="btn btn-sm btn-block btn-outline-danger-white mt-2" onClick={onClickDeleteSelectedNodes}>
              <i className="fa-solid fa-trash mr-2"></i>{l("Eliminar acciones%SA241")}
            </button>
          </div>}

        {numSelectedNodes > 0 &&
          <div className="mt-1 px-2 mr-2 py-1"
            style={{ "position": "absolute", top: "110px", right: "0", zIndex: 5 }}>
            <button className="btn btn-sm btn-block btn-outline-primary-white mt-2" onClick={onClickDuplicateSelectedNodes}>
              <i className="fa-solid fa-clone mr-2"></i>{l("Duplicar acciones")}
            </button>
          </div>}


        <div style={{
          "position": "absolute", bottom: "0px", right: "0", zIndex: 10,
          background: "#f8fafe", width: "60px", height: "20px"
        }}></div>

        {isAnimationOptionShown &&
          <div
            className="mt-1 px-1 mr-2 py-1 animate__animated animate__fadeIn animate__fast"
            style={{
              position: "absolute",
              bottom: "15px",
              right: "0px",
              zIndex: 10,
              background: "#f8fafe"
            }}
          >
            {
              showAnimations
                ? <button className="btn btn-sm btn-block btn-lighter-white mt-1"
                  onClick={() => onClickChangeAnimations(false)}>
                  <i className="fa-solid fa-ban mr-1"></i> {l("Desactivar animaciones%SA239")}
                </button>
                : <button className="btn btn-sm btn-block btn-lighter-white mt-1"
                  onClick={() => onClickChangeAnimations(true)}>
                  <i className="fa-solid fa-toggle-on mr-1"></i> {l("Activar animaciones%SA240")}
                </button>
            }
          </div>
        }

        {/* Extend Controls to implement undo and redo */}
        <Controls showFitView={false} showInteractive={false}
          position="bottom-right" style={{ bottom: "10px" }}>
          {isControlsShown && (
            <>
              <ControlButton onClick={onClickUndo}>
                <i class="fa-solid fa-rotate-left"></i>
              </ControlButton>
              <ControlButton onClick={onClickRedo}>
                <i class="fa-solid fa-rotate-right"></i>
              </ControlButton>
            </>
          )}
        </Controls>

        <Background />
      </ReactFlow>

      {isFlowBeingSaved && (
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#f8fafe50",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 100
          }}
        >
          <Loading />
        </div>
      )}

    </div>
  </div>
);

export default BoardView;